<template>
  <div class="camera fs28">
    <!-- 获取当前定位信息 -->
    <div class="current_location" @click="getCurrentLocation">
      <i class="icon iconfont icon-dingwei"></i>
    </div>

    <div ref="top" class="ctn_top">
      <div class="top orangeToYellow">
        <span class="name">{{ deviceName }}</span>
        <span class="no">编号：{{ no }}</span>
      </div>
      <div class="ctn">
        <div class="item" v-for="item in data" :key="item.key">
          {{ item.label }}： {{ item.value }} {{ item.unit }}
        </div>
      </div>

      <!-- 2气象站 6解码器  都不能拍照 -->
      <van-cell title="分辨率" is-link :value="chooseRatio" @click="visible = true" v-if="type !== 2 && type !== 6" />
      <div class="btns" v-if="type !== 2 && type !== 6">

        <div v-if="no == 1000000350" :style="{ display:'flex',justifyContent: 'center' }">
          <van-button :style="{width: '100px'}" class="btn orangeToYellow" @click="()=>handleTakePic('NIR')">
            NIR
          </van-button>

          <van-button :style="{width: '100px'}" class="btn orangeToYellow" @click="()=>handleTakePic('RBG')">
            RBG
          </van-button>
        </div>

        <van-button v-else class="btn orangeToYellow" @click="handleTakePic">
          立即拍照
        </van-button>
      </div>

      <van-popup v-model="visible" position="bottom" :style="{ width: '100%', height: '6.8rem' }">
        <van-picker title="标题" show-toolbar :columns="ratio" @confirm="onConfirm" @cancel="onCancel"></van-picker>
      </van-popup>
    </div>

    <div class="map">
      <div ref="mapContainer" id="mapContainer"></div>
      <div class="location" @click="handleLocation">
        <i v-if="!locationLoading" class="iconfont icon-dingwei1"></i>
        <van-loading v-else type="spinner" />
      </div>
    </div>

    <Dialog v-model="locationVisible" title="" :show-cancel-button="true" confirm-button-text="确认更新" confirm-button-color="#3A6AE0" cancel-button-text="暂不更新" cancel-button-color="#656773" @confirm="handleConfirm" @cancel="()=>{ locationVisible = false }">
      <template slot="default">
        <div class="location-confirm">
          <div class="location-img">
            <img src="./../../../assets/images/location.png" alt="" width="100%" height="100%">
          </div>
          <div class="location-desc" style="margin-top: 12px;">请确认更新设备坐标信息</div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import API from "@/axios/api";
import { Dialog } from 'vant';

export default {
  components: {
    // Dialog,
    // [Dialog.Component.name]: Dialog.Component,
    Dialog: Dialog.Component,
  },
  data () {
    return {
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "", // 记录的设备号
      deviceName: "",
      data: [
        {
          key: "lon",
          label: "经度",
          value: "",
        },
        {
          key: "lat",
          label: "纬度",
          value: "",
        },
        {
          key: "signal",
          label: "信号强度",
          value: "",
          unit: "dbm",
        },
        {
          key: "vol",
          label: "电压",
          value: "",
          unit: "V",
        },
        {
          key: "volSolar",
          label: "太阳能电压",
          value: "",
          unit: "V",
        },
        {
          key: "gprsNum",
          label: "网卡号码",
          value: "",
          unit: "",
        },
      ],
      visible: false,
      chooseRatio: "",
      ratio: [
        "1600*1200",
        "1280*1024",
        "160*120",
        "1024*576",
        "384*216",
        "1280*720",
        "640*360",
        "1920*1080",
        "2048*1536",
        "3456*1944",
        "2560*1440",
      ],
      type: null,
      locationVisible: false,
      locationLoading: false,
      location: null,
      map: null,
      markers: []

    };
  },

  async mounted () {
    this.type = Number(this.$route.query.type);

    const tH = this.$refs.top.offHeight;

    const dom = document.getElementById("mapContainer");
    dom.style.height = `calc(100% - ${tH}px)`;

    await this.getInfo();
    await this.renderMap();
  },

  methods: {
    // 获取当前位置
    handleLocation () {
      const that = this
      if (this.locationLoading) return this.$toast("正在获取定位中，请勿重复获取")
      this.location = null
      this.locationLoading = true
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认：true
          timeout: 10000, // 设置定位超时时间，默认：无穷大
          offset: [10, 20],  // 定位按钮的停靠位置的偏移量
          zoomToAccuracy: true,  //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          position: 'RB', //  定位按钮的排放位置,  RB表示右下,
          showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,
        })
        geolocation.getCurrentPosition(function (status, result) {
          if (status == 'complete') {
            onComplete(result)
          } else {
            onError(result)
          }
        });

        function onComplete (data) {
          // data是具体的定位信息
          that.locationLoading = false
          that.location = data
          const { lat, lng } = data?.position



          that.map.setZoomAndCenter(9, [lng, lat]);


          // 自定义点标记内容
          var markerContent = document.createElement("div");
          // 点标记中的图标
          var markerImg = document.createElement("img");
          markerImg.className = "markerlnglat";
          markerImg.width = "20"
          markerImg.height = "36"

          markerImg.src = "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png";
          markerContent.appendChild(markerImg);
          var markerSpan = document.createElement("span");
          markerSpan.className = 'marker';


          console.log("markers:", that.markers, that.markers.length);

          if (that.markers?.length > 1) {
            that.markers[that.markers.length - 1].setMap(null);
          }

          markerContent.appendChild(markerSpan);
          that.addMaker(lng, lat, { content: markerContent })
        }

        function onError (data) {
          that.$toast.fail("获取当前定位失败")
          that.locationLoading = false
          that.location = null
          // 定位出错
          console.log("定位出错:", data);
        }
      })
    },

    async getInfo () {
      await API.getGatewayInfo({
        gatewayNo: this.no,
      }).then((res) => {
        const data = res.data;
        this.data.map((item) => {
          item.value = data[item.key];
        });

        this.deviceName = data.deviceName;
      });
    },

    renderMap (_lat, _lng) {
      const val1 = _lat ? _lat : this.data?.[0]?.value
      const val2 = _lng ? _lng : this.data?.[1]?.value
      let lat = val1
      let lng = val2


      console.log(lat, lng);

      if (!isNaN(Number(val1))) {
        // 是转换过后的 wgs84 标准坐标
      } else {
        console.log("进入这里");

        // 这里是GPS NMEA0183 的原始坐标系
        // 格式是 ddmm.mmmm  度分
        // 截取 mm.mmmm / 60 得到的数 拼接前面的dd 得到 wgs84 标准的坐标
        const str2 = val1?.slice(1);
        const str = val2?.slice(1);



        const latD = this.pointIndexOf(str).t;
        const lngD = this.pointIndexOf(str2).t;
        const latM = this.pointIndexOf(str).g;
        const lngM = this.pointIndexOf(str2).g;
        const _latM = latM / 60;
        const _lngM = lngM / 60;
        lat = (Number(latD) + Number(_latM)).toFixed(5);
        lng = (Number(lngD) + Number(_lngM)).toFixed(5);
      }


      var gps = [lat, lng];



      this.data[0].value = lat;
      this.data[1].value = lng;
      const that = this

      AMap.convertFrom(gps, "gps", (status, result) => {
        if (result.info === "ok") {
          let res = result.locations[0];

          var map = new window.AMap.Map("mapContainer", {
            zoom: 9, //级别
            center: [res.lng, res.lat], //中心点坐标
            resizeEnable: true,
            // showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
            // showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
            // panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
            layers: [
              new AMap.TileLayer.Satellite(),
              new AMap.TileLayer.RoadNet(),
            ],
          });

          that.map = map
          that.addMaker(lat, lng)
        }
      });
      // AMap.setLocationSource(this)
      // AMap.setMyLocationEnabled(true);
    },


    addMaker (lat, lng, { content } = {}) {
      try {
        const that = this
        AMap.plugin("AMap.ToolBar", function () {
          //异步加载插件
          var toolbar = new AMap.ToolBar();
          that.map.addControl(toolbar);
        });

        const params = {
          position: new AMap.LngLat(lat, lng)
        }

        if (content) {
          params.content = content
          // params.offset = new AMap.Pixel(-13, -30)
        }

        let marker = new AMap.Marker(params);

        if (content) {
          marker.setContent(content); //更新点标记内容
          marker.setPosition([lat, lng]); //更新点标记位置
        }


        that.markers.push(marker)

        console.log("添加标准：", marker, lat, lng);
        //高德gcj02
        that.map.add(marker);
      } catch (e) {
        console.error("eee:", e);
      }
    },


    getCurrentLocation () {
      if (!this.location) return this.$toast("请先进行定位")
      this.locationVisible = true
    },

    async handleConfirm () {
      await this.$toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      })
      await this.$api.updateDeviceInfo({
        "gatewayNo": this.no,
        "longitude": this.location?.position.lng,
        "latitude": this.location?.position.lat,
      }).then(() => {
        this.$toast.success({
          message: "更新成功"
        })

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
    },

    pointIndexOf (str = "") {
      const index = str?.indexOf(".");
      const t = str?.slice(0, index - 2);
      const g = str?.slice(index - 2);

      return { t, g };
    },

    async handleTakePic (type) {
      if (!this.chooseRatio) return this.$toast("请先选择分辨率");

      this.$toast.loading({
        message: "数据发送中...",
        duration: 0,
      });

      const params = {
        gatewayNo: this.no,
        ratio: this.ratio?.indexOf(this.chooseRatio) + 1,
      }

      if (this.no === "1000000350") {
        if (type === "NIR") {
          params.nir = true
        } else {
          params.nir = false
        }
      } else {
        params.nir = this.no === "1000000333" ? true : false
      }


      await API.takePicture(params)
        .then((res) => {
          if (res.errcode === 0) {
            this.$toast.success("拍照成功");
          } else {
            this.$toast.fail(res.errmsg || "拍照失败");
          }
        })
        .catch((err) => {
          this.$toast.fail(err.message || "拍照失败");
        })
        .finally(() => {
          setTimeout(() => {
            this.$toast.clear();
          }, 1500);
        });
    },

    onConfirm (data) {
      console.log(data);
      this.chooseRatio = data;
      this.onCancel();
    },

    onCancel () {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.camera {
  height: 100%;
}

.top {
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  padding: 0 10px;

  .name {
    margin-right: 20px;
  }
}
.ctn {
  padding: 10px 16px;

  .item {
    line-height: 30px;
  }
}

.btns {
  text-align: center;

  .btn {
    width: 70%;
    color: #ffffff;
    margin-top: 20px;
  }
}

.current_location {
  position: fixed;
  top: 90px;
  right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  color: #ffffff;
  background: #3a6ae0;
  box-shadow: 0px 2px 6px rgba(58, 106, 224, 0.25);
  border-radius: 50%;

  i {
    font-size: 22px;
  }
}

.location-confirm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 14px 0;

  .location-img {
    width: 50%;
  }
}

#mapContainer {
  width: 100%;
  height: 300px;
  margin-top: 30px;
}

.map {
  position: relative;

  .location {
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    background: #3a6ae0;
    border-radius: 15.1467px;

    i {
      color: #ffffff;
      font-size: 32px;
    }
  }
}

::v-deep .amap-logo,
::v-deep .amap-copyright,
::v-deep .amap-maptype-wrap,
::v-deep .amap-maptype-list {
  display: none !important;
}
</style>
